import { Box } from "@mui/material"
import ScrollIndicator from "../ScrollIndicator"

const HomeBanner = () => {
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: "86vh", // Force video container to full screen height
        overflow: "hidden",
      }}
    >
      <video
        // src="https://eightfourthree-assets.s3.us-east-2.amazonaws.com/intro_video/h.264+APP+Intro+e0125_2202_1.mp4"
        src="https://eightfourthree-assets.s3.us-east-2.amazonaws.com/intro_video/h.264+APP+Intro+2.mp4"
        autoPlay
        loop
        playsInline
        controls
        muted
        preload="auto"
        style={{
          width: "100%",
          height: "100%",
          maxHeight: "86vh",
          objectFit: "cover",
          display: "block",
        }}
      ></video>
      <ScrollIndicator />
    </Box>
  )
}

export default HomeBanner
